var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    _vm._b(
      { staticClass: "ma-3", attrs: { color: _vm.color } },
      "v-card",
      _vm.$attrs,
      false
    ),
    [
      _vm.title
        ? _c("v-card-title", { staticClass: "pb-0 mb-4" }, [
            _c("h3", { staticClass: "text-h6" }, [_vm._v(_vm._s(_vm.title))]),
          ])
        : _vm._e(),
      _vm.hasSlot
        ? _c("v-card-text", { class: _vm.textClass }, [_vm._t("default")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }